const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';

export const setSearchText = (data) => {
  //console.log(data);
  return { type: SET_SEARCH_TEXT, payload: data };
};

const initialState = {
  searchText: ''
};

export default function searchTextReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SEARCH_TEXT: {
      return { ...state, searchText: action.payload };
    }

    default:
      return state;
  }
}
